import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import * as firebase from 'firebase/app';
import { AuthService } from '../../services/auth/auth.service';
import { WindowService } from '../../services/window/window.service';
import { AngularFireDatabase } from 'angularfire2/database'
import { AngularFirestore } from 'angularfire2/firestore';
import { Observable } from 'rxjs/Rx';
import { User } from '../datamodel/user';
//import { MessageService } from '../../services/message/message.service';
//import { AlertService } from '../../services/alert/alert.service';


@Component({
    selector: 'app-forgot-password',
    templateUrl: './forgot-password.component.html',
    styleUrls: ['./forgot-password.component.scss'],
    providers: [WindowService]
})


export class ForgotPasswordComponent implements OnInit {
    //set page header title
    title = 'Forgot your Password ?';

    @ViewChild('email') email: ElementRef;
    public lastError: string = null;

    constructor(private auth: AuthService, private win: WindowService, private afs: AngularFirestore) {

    }

    onSubmit() {
        this.lastError = null;
        this
            .auth
            .resetPassword(this.email.nativeElement.value)
            .catch((error) => {
                this.lastError = error.message;
            });
    }

    ngOnInit() {
    
    }
}



// WEBPACK FOOTER //
// ./src/app/modules/forgot-password/forgot-password.component.ts